module.exports = __webpack_public_path__ + "img/sendouts-inactive.d2531fa9.svg";